import qs from 'query-string';
import sap from '@shopee/web_enhance_sap';
import { isObject, isEmptyObject, isFormData } from './utils';

/**
 * 添加 SAP Header 信息
 * @param config
 * @returns
 */
export const addSecurityRequestHeader = config => {
  const { url = '', method = 'GET', data, params } = config;

  // 过滤 FormData 数据请求
  if (data && isFormData(data)) {
    return config
  }

  let body = data;
  if (method.toLowerCase() === 'post' && isObject(data)) {
    try {
      body = JSON.stringify(data);
    } catch (error) {
      // EMPTY
    }
  }

  let requestUrl = url;
  // 如果有参数，也需要添加到 url 中
  if (!isEmptyObject(params)) {
    const queryString = qs.stringify(params, { sort: (a, b) => a.localeCompare(b) })
    if (queryString.length > 0) {
      if (requestUrl[requestUrl.length - 1] === '?') {
        requestUrl += queryString;
      } else if (requestUrl.includes('?')) {
        requestUrl = `${requestUrl}&${queryString}`;
      } else {
        requestUrl = `${requestUrl}?${queryString}`;
      }
    }
  }

  const signature = sap.generateSignEntry(requestUrl, body);
  Object.assign(config.headers, signature);

  return config;
};



// WEBPACK FOOTER //
// ./foody/src/utils/interceptors.js